var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1289 8.73188L15.772 6.375L12.0005 10.1465L8.22852 6.37451L5.87163 8.7314L9.6436 12.5034L5.87305 16.2739L8.22993 18.6308L12.0005 14.8602L15.7706 18.6303L18.1274 16.2734L14.3574 12.5034L18.1289 8.73188Z",
    fill: "#D5FD95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconSmall);
export default __webpack_public_path__ + "static/media/close-icon-small.3a1418cf059d829e1eca9ae69d578870.svg";
export { ForwardRef as ReactComponent };